module.exports = __webpack_public_path__ + "img/country_road.c6ff9e0d.jpg";